var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'loggedIn': _vm.authenticated, 'login': !_vm.authenticated },attrs:{"id":"app"}},[(_vm.loading)?_c('div',{staticClass:"loader"},[_c('spinner',{attrs:{"size":"big"}})],1):_vm._e(),_vm._v(" "),(_vm.loading === false && _vm.ok)?_c('router-view'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6138659c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 